import * as Yup from "yup";

export default function validation_participant_password(field, acc) {
  const { field_name, linked_fields, field_validation } = field; // Extract field details

  const minLength = field_validation?.min?.[0]; // Minimum length value
  const minLengthMessage = field_validation?.min?.[1]; // Error message for minimum length
  const requiredLinkedMessage = "Required field."; // Error message for linked validation

  // Start building the validation schema
  let validationSchema = Yup.string()
    .nullable() // Allows the field to be empty
    .trim() // Removes leading and trailing whitespace
    .test(
      "linked-required",
      requiredLinkedMessage,
      function (value) {
        // If the current field is empty, check linked fields
        if (!value) {
          const siblingValues = linked_fields?.map((linked) => this.parent[linked]) || [];
          return siblingValues.every((v) => !v); // Pass validation if all linked fields are empty
        }
        return true; // Current field has a value, validation passes
      }
    );

  // Add `min` validation only if defined in `field_validation`
  if (minLength && minLengthMessage) {
    validationSchema = validationSchema.min(minLength, minLengthMessage);
  }

  return {
    [field_name]: validationSchema.notRequired(),
    ...acc, // Merge with the existing schema
  };
}
